// extracted by mini-css-extract-plugin
export default {"maskTabPanelContent":"MaskTabPanel_maskTabPanelContent__4M2Ey"};